import { CompanyAccountsPage } from './pages/CompanyAccountsPage';

/** The Accounts tab of Company settings; its sibling tabs and the `/company` redirect live in `company-settings`. */
export const COMPANY_ACCOUNT_ROUTES = [{ path: 'company/accounts', element: <CompanyAccountsPage /> }];
